import { ModelBase, observable } from "@shoothill/core";
//import { PermitTypeDTO } from "./PermitModel";

export class InductionAdminPermitListModel extends ModelBase<InductionAdminPermitListModel> {
    public id: string = "";
    @observable
    public permitTypeName: string = "";
    @observable
    public permitNumber: number = 0;
    @observable
    public issuedByDate: string = "";
    @observable
    public issuedByUserName: string = "";
    @observable
    public issuedToDate: string = "";
    @observable
    public issuedToUserName: string = "";
    @observable
    public surrenderedByDate: string | null = null;
    @observable
    public surrenderedByUserName: string | null = null;
    @observable
    public cancelledByDate: string | null = null;
    @observable
    public cancelledByUserName: string | null = null;
    @observable
    public projectId: string = "";

    constructor() {
        super();
    }

    fromDto(dto: InductionAdminPermitListDTO): void {
        this.id = dto.id;
        this.permitTypeName = dto.permitTypeName;
        this.permitNumber = dto.permitNumber;
        this.issuedByDate = dto.issuedByDate;
        this.issuedByUserName = dto.issuedByUserName;
        this.issuedToDate = dto.issuedToDate;
        this.issuedToUserName = dto.issuedToUserName;
        this.surrenderedByDate = dto.surrenderedByDate;
        this.surrenderedByUserName = dto.surrenderedByUserName;
        this.cancelledByDate = dto.cancelledByDate;
        this.cancelledByUserName = dto.cancelledByUserName;
        this.projectId = dto.projectId;
    }

    toDto(model: InductionAdminPermitListModel): void {
        throw new Error("Method not implemented.");
    }
}

export interface InductionAdminPermitListDTO {
    id: string;
    permitTypeName: string;
    permitNumber: number;
    issuedByDate: string;
    issuedByUserName: string;
    issuedToDate: string;
    issuedToUserName: string;
    surrenderedByDate: string | null;
    surrenderedByUserName: string | null;
    cancelledByDate: string | null;
    cancelledByUserName: string | null;
    projectId: string;
}

export interface InductionAdminPermitListAndRelatedDTO {
    permitListItems: InductionAdminPermitListDTO[];
    //permitTypes: PermitTypeDTO[];
}
